export default {
  title: 'Transferir a app {{app}}',
  qr_code_desc: 'Digitalize este código QR com o seu telemóvel para transferir a app',
  cta: 'Transfira a app e inicie sessão para obter {{amount}} de cashback!',
  download_from: 'Ou transfira em:',
  direct_link: 'Ligação direta:',
};
